import { MessageFrom } from "../enum/message_from";
import { MessageStatus } from "../enum/message_status";

class MessageModel {
  constructor({
    id = "",
    uniqueKey = "",
    message = "",
    from = MessageFrom.user,
    status = MessageStatus.delivered,
    dateString = "",
    images = [],
  } = {}) {
    this._id = id;
    this._uniqueKey = uniqueKey;
    this._message = message;
    this._from = from;
    this._status = status;
    this._dateString = dateString;
    this._images = images;
  }

  get id() {
    return this._id;
  }

  get uniqueKey() {
    return this._uniqueKey;
  }

  get message() {
    return this._message;
  }

  set message(value) {
    if (typeof value !== "string") {
      throw new Error("message must be a string");
    }
    this._message = value;
  }

  get from() {
    return this._from;
  }

  set from(value) {
    if (!Object.values(MessageFrom).includes(value)) {
      throw new Error(`Invalid 'from' value. Allowed values: ${Object.values(MessageFrom).join(", ")}`);
    }
    this._from = value;
  }

  get status() {
    return this._status;
  }

  set status(value) {
    if (!Object.values(MessageStatus).includes(value)) {
      throw new Error(`Invalid 'status' value. Allowed values: ${Object.values(MessageStatus).join(", ")}`);
    }
    this._status = value;
  }

  get dateString() {
    return this._dateString;
  }

  set dateString(value) {
    if (typeof value !== "string") {
      throw new Error("dateString must be a String");
    }
    this._dateString = value;
  }

  get images() {
    return this._images;
  }

  toJSON() {
    return {
      id: this._id,
      uniqueKey: this._uniqueKey,
      message: this._message,
      from: this._from,
      status: this._status,
      dateString: this._dateString,
      images: this._images,
    };
  }
}

export default MessageModel;
